import React from 'react'
import Box from '@mui/material/Box'

const TableBody = ({children, className}) =>{
    return(
        <Box
            className={className}
            sx={{
                borderRadius: '5px',
                display: 'grid',
                gridColumnStart: 'span 12',
                gridRowGap: '5px',
                gridRowStart: 'span 11',
                gridTemplateColumns: 'repeat(12, 1fr)',
                maxHeight: '40px'
            }}
        >
            {children}
        </Box>
    )
}

export default TableBody
